import { DateTime } from "luxon";
import type { GetQuotationrequestRSDef } from "../../../api/quotation/types";
import { brand } from "../../../context";
import { StatusTag, ViewOfferButton, ViewQuotationChatButton } from "./components";

export type QuotationRequestDesktopTableProps = {
  quotations: GetQuotationrequestRSDef[];
};

export function QuotationRequestDesktopTable({ quotations }: QuotationRequestDesktopTableProps) {
  return (
    <table className="Table Quotations__body__desktoptable" data-brand={brand}>
      <QuotationTableHeader />
      <tbody>
        {quotations.map((q, idx) => (
          <QuotationTableRow key={`${idx}-${q.reference}`} quotation={q} index={idx} />
        ))}
      </tbody>
    </table>
  );
}

export function QuotationTableHeader() {
  return (
    <thead>
      <tr>
        <th className="text-left! w-[3rem]">#</th>
        <th className="text-left!">Title</th>
        <th className="text-left! w-[11rem]">Trip Start Date</th>
        <th className="text-left!">Created</th>
        <th className="text-left!">Due Date</th>
        <th className="text-left! w-[8rem]">Status</th>
        <th className="text-left! w-[6rem]">Actions</th>
      </tr>
    </thead>
  );
}

export type QuotationTableRowProps = {
  quotation: GetQuotationrequestRSDef;
  index: number;
};

export function QuotationTableRow({ quotation, index }: QuotationTableRowProps) {
  return (
    <tr className="odd:bg-gray-200">
      <td className="text-left! w-[3rem] text-xs!">{index + 1}</td>
      <td className="text-left! text-xs!">{quotation?.title || "N/A"}</td>
      <td className="text-left! w-[11rem] text-xs!">
        {quotation.trip_start_date
          ? DateTime.fromISO(quotation.trip_start_date).toLocaleString(DateTime.DATE_FULL)
          : "N/A"}
      </td>
      <td className="text-left! text-xs!">
        {quotation.created
          ? DateTime.fromISO(quotation.created).toLocaleString(DateTime.DATETIME_FULL)
          : "N/A"}
      </td>
      <td className="text-left! text-xs!">
        {quotation.due_date
          ? DateTime.fromISO(quotation.due_date).toLocaleString(DateTime.DATETIME_FULL)
          : "N/A"}
      </td>
      <td className="text-left! w-[8rem] text-xs!">
        <StatusTag
          offerStatus={quotation.offer_status}
          status={quotation.status}
          statusDisplay={quotation.status_display}
        />
      </td>
      <td className="text-left! w-[6rem] text-xs!">
        <div className="flex flex-col gap-1">
          {quotation.chat_session_uid && (
            <ViewQuotationChatButton chatSessionUid={quotation.chat_session_uid} />
          )}
          {!!quotation?.offer_sent_date && quotation.offer_reference && (
            <ViewOfferButton offerReference={quotation.offer_reference} />
          )}
        </div>
      </td>
    </tr>
  );
}
